import React, { useState } from "react";
import Header from "../../layout/Header";
import { useNavigate } from "react-router-dom";

import LoginBannerhi from "../../../assets/images/HindiBanner.png";
import LoginBannermr from "../../../assets/images/MarathiBanner.png";
import LoginBannerka from "../../../assets/images/KannadaBanner.png";
import LoginBannerte from "../../../assets/images/TeluguBanner.png";
import LoginBannerpb from "../../../assets/images/PunjabiBanner.png";
import LoginBannergu from "../../../assets/images/GujaratiBanner.png";
import LoginBannerta from "../../../assets/images/tamilBanner.png";
import LoginBannerbn from "../../../assets/images/BengaliBanner.png";
import LoginBanneror from "../../../assets/images/OriyaBanner.png";
import { Loader } from "../../loader";
import RewardImage from "../../../assets/images/Rewards.png";
import ScanMoreImg from "../../../assets/images/Scanmore.png";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { claimStatus, rewardMoney } from "../../auth/redux/store";
import ConditionImg from '../../../assets/images/Termsconditions.png';
import ProgramImg from '../../../assets/images/programDetails.png'
import { useParams } from "react-router-dom";
import ReactGA from 'react-ga4';
export const Home = () => {
  const { t, i18n } = useTranslation();
  const { lang } = useParams();
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  dispatch(claimStatus(false));
  dispatch(rewardMoney(0));


  let bannerImageSrc;
  if (lang === 'hi') {
    bannerImageSrc = LoginBannerhi;
  } else if (lang === 'mr') {
    bannerImageSrc = LoginBannermr;
  } else if (lang === 'kn') {
    bannerImageSrc = LoginBannerka;
  } else if (lang === 'te') {
    bannerImageSrc = LoginBannerte;
  } else if (lang === 'pa') {
    bannerImageSrc = LoginBannerpb;
  } else if (lang === 'gu') {
    bannerImageSrc = LoginBannergu;
  } else if (lang === 'ta') {
    bannerImageSrc = LoginBannerta;
  } else if (lang === 'bn') {
    bannerImageSrc = LoginBannerbn;
  } else if (lang === 'or') {
    bannerImageSrc = LoginBanneror;
  }
  else {
    bannerImageSrc = LoginBannerhi;
  }

  return (
    <>
      <Header />
      <div className="main">
        <div className="container p-0">
          {loading && <Loader />}
          <div className="card border-0">
            <img
              src={bannerImageSrc}
              className="img-fluid w-100"
              alt="banner"
            />
            <div className="card-body pb-2 pt-0 pb-2">
              <div className="homeContent">

                <div
                  className="card align-items-center text-center"
                  onClick={() => {
                    ReactGA.event({
                      category: 'User Home Rewards',
                      label: 'Home Rewards Button',
                      action: 'Clicked Home Rewards Button',
                    });
                    navigate(`/${lang}/myrewards`)
                  }}

                >
                  <div className="card-body">
                    <img
                      src={RewardImage}
                      className="homeImage"
                      alt="homeImage"
                    />
                    <p className="modal-title mt-2">{t("Rewards")}</p>
                  </div>
                </div>

                <div
                  className="card align-items-center text-center"
                  onClick={() => {
                    ReactGA.event({
                      category: 'Home Scan Product',
                      label: 'Scan Product Button',
                      action: 'Clicked Home Scan Product Button',
                    });
                    navigate(`/${lang}/scanproduct`)
                  }}

                >
                  <div className="card-body">
                    <img
                      src={ScanMoreImg}
                      className="homeImage"
                      alt="homeImage"
                    />
                    <p className="modal-title mt-2">{t("Scanmore")}</p>
                  </div>
                </div>

                {/* <div
                  className="card align-items-center text-center"
                  onClick={()=> {
                    ReactGA.event({
                      category: 'User Home Terms & Cond',
                      action: 'CLK_HOME_TNC_BTN',
                    });
                    navigate(`/${lang}/strongarmdhamaka`) 
                  }}   
                >
                  <div className="card-body">
                    <img
                      src={ConditionImg}
                      className="homeImage"
                      alt="homeImage"
                    />
                    <p className="modal-title mt-2">{t("TermsandConditons")}</p>
                  </div>
                </div> 
                
                <div
                  className="card align-items-center text-center"
                  onClick={()=> {
                    ReactGA.event({
                      category: 'User Home Program Details',
                      action: 'CLK_HOME_PGM_BTN',
                    });
                    navigate(`/${lang}/programDetails`) 
                  }}    
                >
                  <div className="card-body">
                    <img
                      src={ProgramImg}
                      className="homeImage"
                      alt="homeImage"
                    />
                    <p className="modal-title mt-2">{t("programDetails")}</p>
                  </div>
                </div> */}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Home;
